class ReadMoreElement extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.content = this.querySelector('[data-read-more-content]');
    this.boundToggle = this.toggle.bind(this);

    if (this.button && this.content) {
      this.checkContentOverflow();

      if (!this.button.hasAttribute('hidden')) {
        [this.button, this.content].forEach((el) => el.addEventListener('click', this.boundToggle));
      }
    }
  }

  /**
   * Check if content exceeds the line clamp
   */
  checkContentOverflow() {
    if (!this.content) return;
    const contentOverflows = this.content.scrollHeight > this.content.offsetHeight;

    if (!contentOverflows) {
      this.button.setAttribute('hidden', '');
      this.content.classList.remove('cursor-pointer');
      this.content.classList.remove('line-clamp-[var(--line-clamp)]');
    }
  }

  /**
   * Open the collapsible element
   */
  open() {
    this.setAttribute('aria-expanded', 'true');
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.setAttribute('aria-expanded', 'false');
  }

  /**
   * Toggle the collapsible element
   */
  toggle() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.close() : this.open();
  }

  disconnectedCallback() {
    if (!this.button.hasAttribute('hidden')) {
      [this.button, this.content].forEach((el) =>
        el.removeEventListener('click', this.boundToggle)
      );
    }
  }
}

customElements.define('read-more', ReadMoreElement);
